import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=2c1ecedc&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"
import style0 from "./Suggestions.vue?vue&type=style&index=0&id=2c1ecedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ecedc",
  null
  
)

export default component.exports